<hmf-breadcrumbs
	[breadcrumbs]="breadcrumbs"
	[truncate]="true"
	[numOfShownBreadcrumbs]="2"
	[currentPageIncluded]="false"
	alignment="left" />
